import { stringLiteral } from "@babel/types";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  child,
  get,
  push,
  ref,
  serverTimestamp,
  update,
} from "firebase/database";
import { database } from "../components/fBase";
import { isBeta } from "../components/webConfig";
import { ISid, saveErrParty } from "./PacketManagerTS";

const dbRef = ref(database, isBeta ? "Beta/LoginChk" : "Live/LoginChk");
const isDevMode = process.env.NODE_ENV === "development" ? true : false;

export const loginCheckModalChkCnt = 2;

// https 방식인지, 매크로 방식인지에 따라 호출 함수가 다르다.
// 아이디 변경 창에서는 이 함수로 로그인체크를 한다.
export const getIsMacroLoginCheck = async (subsid: number) => {
  console.log(subsid);
  if (subsid === 1001) {
    return true;
  } else {
    return false;
  }
};

export const LoginCheckMainWeb = async (
  subsid: number,
  id: string,
  pw: string,
  idType?: string
) => {
  let data = {
    isValid: false, // 유효한 계정인지
    hasMembership: false, // 이용권이 있는지
    needCheck: false, // 계정 직접 확인이 필요한 경우
    addInfo: "", //추가 정보
  };

  // 아래 아이디 타입은 체크가 불가능 하므로 맞는것으로 간주하고 패스 리턴.
  if (
    idType === "페이스북" ||
    idType === "T계정" ||
    idType === "T ID" ||
    idType === "네이버" ||
    idType === "리디" ||
    idType === "카카오" ||
    idType === "트위터" ||
    idType === "CJ ONE"
  ) {
    console.log("못하는 것들은 패스 ");

    data.isValid = true;
    data.hasMembership = true;

    return data;
  }

  switch (subsid) {
    case 1001:
      data = await LoginCheckWeb_Netflix(id, pw);
      break;
    case 1002:
      data = await LoginCheckWeb_Netflix(id, pw);
      break;
    case 1100:
      data = await LoginCheckWeb_Netflix(id, pw);
      break;
    case 2000:
      data = await LoginCheckWeb_Watcha(id, pw);
      break;
    case 3000:
      data = await LoginCheckWeb_Wavve(id, pw);
      break;
    case 4000:
    case 4001:
    case 4002:
    case 4100:
      // idType: 20 = 티빙, 10 = cjone
      data = await LoginCheckWeb_Tving(id, pw, idType);
      break;
    case 5000:
    case 5001:
    case 5002:
      data = await LoginCheckWeb_Disney(id, pw);
      break;

    case 16000:
      data = await LoginCheckWeb_Laftel(id, pw);
      break;
    case 20000:
    case 20001:
      data = await LoginCheck_Nba(id, pw);
      break;
    case 27000:
      data = await LoginCheckWeb_Realclass(id, pw);
      break;

    default:
      break;
  }

  console.log("data", data);

  return data;
};

// 로긴 체크_넷플릭스
export const LoginCheckWeb_Netflix = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능

  let form = new FormData();
  form.append("email", id);
  form.append("password", pw);

  try {
    const body = {
      id,
      pw,
      pw_new: "",
    };

    let addr;

    if (isDevMode) {
      addr = `/loginChecker/logincheck_Netflix`;
    } else {
      addr = `/checker/logincheck_Netflix`;
    }

    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res?.data?.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log(error);
  }
};

// 로긴 체크_웨이브
export const LoginCheckWeb_Wavve = async (id: string, pw: string) => {
  const body = {
    id: id,
    pw: pw,
  };

  try {
    let addr;

    if (isDevMode) {
      addr = `/loginChecker/logincheck_Wavve`;
    } else {
      addr = `/checker/logincheck_Wavve`;
    }

    const res = await axios.post(addr, body);
    console.log(res);
    console.log("✅ success: ", res.data.data);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

// 로긴 체크_티빙
export const LoginCheckWeb_Tving = async (
  id: string,
  pw: string,
  ldType?: string
) => {
  // 티빙, cjone 체크 가능
  // loginType: 20 = 티빙, 10 = cjone
  let loginType = 10;
  let addr;

  if (ldType === "TVING ID" || ldType === "TVINGID") {
    loginType = 20;
  }

  const body = {
    id: id,
    pw: pw,
    // loginType: loginType,
    loginType: 20, // 일단 티빙으로 고정하자
  };

  if (isDevMode) {
    addr = `/loginChecker/logincheck_Tving`;
  } else {
    addr = `/checker/logincheck_Tving`;
  }

  try {
    const res = await axios.post(addr, body);
    console.log("✅ success: ", res);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

// 로긴 체크_라프텔
export const LoginCheckWeb_Laftel = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능

  const body = {
    id: id,
    pw: pw,
  };

  let addr;

  if (isDevMode) {
    addr = `/loginChecker/logincheck_Laftel`;
  } else {
    addr = `/checker/logincheck_Laftel`;
  }

  try {
    const res = await axios.post(addr, body);
    console.log("✅ success: ", res.data.data);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

// 로긴 체크_왓챠
export const LoginCheckWeb_Watcha = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능
  const body = {
    id: id,
    pw: pw,
  };

  try {
    let addr;

    if (isDevMode) {
      addr = `/loginChecker/logincheck_Watcha`;
    } else {
      addr = `/checker/logincheck_Watcha`;
    }

    const res = await axios.post(addr, body);
    // console.log("✅ success: ", res.data);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

// 로긴 체크_아마존
export const LoginCheckWeb_Amazon = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능

  console.log(id, pw);
  let form = new FormData();
  form.append("appActionToken", "q0ioSGaRLnfxbzDfpj2Bo2F8OI0Jkj3D");
  form.append("appAction", "SIGNIN");
  form.append("metadata1", "");
  form.append("workflowState", "");
  form.append("prevRID", "ape: MzQyNFBERUM1RDVWMjVIWlhUNUM =");
  form.append(
    "openid.return_to",
    "ape:aHR0cHM6Ly93d3cucHJpbWV2aWRlby5jb20vcmVnaW9uL2ZlL2F1dGgvcmV0dXJuL3JlZj1hdl9hdXRoX2FwP19lbmNvZGluZz1VVEY4JmxvY2F0aW9uPSUyRnJlZ2lvbiUyRmZlJTJGZ3AlMkZ2aWRlbyUyRnNpZ251cCUyRnJlZiUzRGR2bV9NTFBfRkVfSm9pbl8xJTNGX2VuY29kaW5nJTNEVVRGOCUyNnJlZiUzRGR2bV9NTFBfRkVfSm9pbl8x"
  );
  form.append("email", id);
  form.append("password", pw);
  form.append("create", "0");

  const config: AxiosRequestConfig = {
    url: "https://www.amazon.com/ap/signin",
    // credentials: "include",
    headers: {
      "User-Agent":
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:98.0) Gecko/20100101 Firefox/98.0",
      Accept:
        "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,*/*;q=0.8",
      "Accept-Language": "ko-KR,ko;q=0.8,en-US;q=0.5,en;q=0.3",
      "Content-Type": "application/x-www-form-urlencoded",
      "Upgrade-Insecure-Requests": "1",
      "Sec-Fetch-Dest": "document",
      "Sec-Fetch-Mode": "navigate",
      "Sec-Fetch-Site": "same-origin",
      "Sec-Fetch-User": "?1",
    },
    // referrer: "https://www.amazon.com/ap/signin",
    data: form,
    method: "POST",
    // mode: "cors",
  };

  try {
    const res: AxiosResponse = await axios(config);
    console.log("노 에러는 4444", res);
    alert("맞음");
  } catch (error) {
    console.log("에러는  3333", error);
    alert("틀렸다");
  }
};

// 로긴 체크_디즈니
export const LoginCheckWeb_Disney = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능

  console.log(id, pw);
  let form = new FormData();
  form.append("email", id);
  form.append("password", pw);

  try {
    const body = {
      id,
      pw,
      pw_new: "",
    };

    let addr = "";
    if (isDevMode) {
      addr = `/loginChecker/logincheck_Disney`;
    } else {
      addr = `/checker/logincheck_Disney`;
    }

    const res = await axios.post(addr, body);

    if (res?.status === 200) {
      return res?.data?.data;
    } else {
      return res.status;
    }
  } catch (error) {
    console.log("에러는  3333", error);
  }
};

// 로긴 체크_테니스TV
export const LoginCheckWeb_TennisTV = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능

  console.log("테니스티비", id, pw);
  let form = new FormData();
  form.append("username", "angela.hyesun@gmail.com");
  form.append("password", "tentenclub12#");
  form.append("submitAction", "Log+In");

  const config: AxiosRequestConfig = {
    url: "https://sso.tennistv.com/auth/realms/TennisTV/login-actions/authenticate?session_code=MbCQ9c5NhXsYjDRPvO8aQG-vMViisDXs3MTIjzwx-98&execution=e8feff28-3d42-4a5c-87ff-a0224cc16b2f&client_id=tennis-tv-web&tab_id=vrNgBpG7pZk",
    // credentials: "include",
    headers: {
      "User-Agent":
        "Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:101.0) Gecko/20100101 Firefox/101.0",
      Accept:
        "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,*/*;q=0.8",
      "Accept-Language": "ko-KR,ko;q=0.8,en-US;q=0.5,en;q=0.3",
      "Content-Type": "application/x-www-form-urlencoded",
      "Upgrade-Insecure-Requests": "1",
      "Sec-Fetch-Dest": "document",
      "Sec-Fetch-Mode": "navigate",
      "Sec-Fetch-Site": "same-origin",
      "Sec-Fetch-User": "?1",
    },
    data: form,
    method: "POST",
    // mode: "cors",
  };

  try {
    const res = await axios(config);
    console.log("노 에러는 4444", res);
    alert("맞음");
  } catch (error) {
    console.log("에러는  3333", error);
    alert("틀렸다");
  }
};

// subsid별로 로그인 체크를 쓰고 있는지 체크
export const getNowUseSystemLoginCheckWeb = async (subsid: number) => {
  let nowUse = false;

  const subsIdRef = child(dbRef, String(subsid));

  try {
    return await get(subsIdRef).then((snapshot) => {
      if (snapshot.val() !== null) {
        nowUse = snapshot.val().use;
      } else {
        nowUse = false;
      }

      return nowUse;
    });
  } catch (error) {
    return error;
  }
};

// reportCntCriteria 체크
export const getReportLimitCountWeb = async (subsid: number) => {
  let cnt = 0;

  const reportLimitCntRef = child(dbRef, "reportLimitCnt");

  try {
    return await get(reportLimitCntRef)
      .then((snapshot) => {
        if (snapshot.val() !== null) {
          cnt = snapshot.val();
        }
      })
      .then(() => {
        return addReportCntWeb(subsid, cnt);
      });
  } catch (error) {
    return error;
  }
};

// 구독별로 report 갯수를 1 증가 시킨다.
// 만약, 5개 이상 접수되었을경우에는 1증가시키지 않고, use를 false로 변경하고 reportCnt는 0으로 초기화한다.
export const addReportCntWeb = async (subsid: number, cnt: number) => {
  let curCnt = 0;

  const subsIdRef = child(dbRef, String(subsid));

  try {
    return await get(subsIdRef).then((snapshot) => {
      if (snapshot.val() !== null) {
        curCnt = snapshot.val().reportCnt;
      }

      if (curCnt >= cnt) {
        return turnOffLoginChk(subsid);
      } else {
        return updateReportCnt(subsid, curCnt + 1);
      }
    });
  } catch (error) {
    return error;
  }
};

// 구독별 유저 리포트 개수 저장
export const updateReportCnt = async (subsid: number, cnt: number) => {
  const subsIdRef = child(dbRef, String(subsid));

  try {
    return await update(subsIdRef, {
      reportCnt: cnt,
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

// 구독별 로그인체크 off.
export const turnOffLoginChk = async (subsid: number) => {
  const subsIdRef = child(dbRef, String(subsid));

  try {
    return await update(subsIdRef, {
      useApp: false,
      use: false,
      reportCnt: 0,
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

// reportLimitCnt 수정
export const updateReportLimitCnt = async (updateValue: number) => {
  try {
    return await update(dbRef, {
      reportLimitCnt: updateValue,
    }).then((res) => {
      console.log(res);
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

// 리포트 파티 아이디를 저장
export const savePartyIdWeb = async (
  subsid: number,
  partyid: number,
  loginType: string,
  wrong: "login" | "membership" | "needCheck",
  where: "create" | "change",
  sid: ISid
) => {
  console.log(subsid, partyid, loginType, wrong, where);

  try {
    saveErrParty({
      sid,
      subsid,
      pid: partyid,
      idtype:
        loginType === "로그인 수단 선택" || loginType === "" ? "" : loginType,
      wrong:
        wrong === "login"
          ? 1
          : wrong === "membership"
          ? 2
          : wrong === "needCheck"
          ? 4
          : 0,
      state: where === "create" ? 1 : where === "change" ? 2 : 0,
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

// subsid별로 로그인 체크를 쓰고 있는지 체크
export const getCheckNetflixMacroWeb = async (type: "join" | "pwReset") => {
  const dbRef = ref(database, isBeta ? "Beta/Macro" : "Live/Macro");

  let nowUse = false;

  const typeRef = child(
    dbRef,
    type === "join"
      ? "Netflix_ExtraJoin"
      : type === "pwReset"
      ? "Netflix_System_PWReset"
      : ""
  );

  try {
    return await get(typeRef).then((snapshot) => {
      if (snapshot.val() !== null) {
        nowUse = snapshot.val().use;
      } else {
        nowUse = false;
      }

      return nowUse;
    });
  } catch (error) {
    return error;
  }
};

interface EC_DS_1 {
  data: {
    result: number;
    id?: string;
    token?: string;
  };
}

// subsid별로 로그인 체크를 쓰고 있는지 체크
export const getDisneyOTP = async (id: string, pw: string) => {
  const body = {
    id,
    pw,
  };

  const addr = `${isDevMode ? "/loginChecker" : "/checker"}/ec_ds_1`;

  try {
    const res = await axios.post<EC_DS_1>(addr, body);
    console.log("✅ success: ", res);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

interface EC_DS_2 {
  data: {
    result: number;
    actionGrant?: string;
  };
}

// subsid별로 로그인 체크를 쓰고 있는지 체크
export const checkDisneyOTP = async (
  id: string,
  token: string,
  otp: string
) => {
  const body = {
    id,
    token,
    otp,
  };

  const addr = `${isDevMode ? "/loginChecker" : "/checker"}/ec_ds_2`;

  try {
    const res = await axios.post<EC_DS_2>(addr, body);
    console.log("✅ success: ", res);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

interface EC_DS_3 {
  data: {
    result: number;
    email_new?: string;
  };
}

// subsid별로 로그인 체크를 쓰고 있는지 체크
export const changeDisneyEmail = async (
  token: string,
  actionGrant: string,
  email_new: string
) => {
  const body = {
    token,
    actionGrant,
    email_new,
  };

  const addr = `${isDevMode ? "/loginChecker" : "/checker"}/ec_ds_3`;

  try {
    const res = await axios.post<EC_DS_3>(addr, body);
    console.log("✅ success: ", res);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

// 로긴 체크_nba
export const LoginCheck_Nba = async (id: string, pw: string) => {
  const body = {
    id: id,
    pw: pw,
  };
  let addr;
  if (isDevMode) {
    addr = `/loginChecker/logincheck_Nba`;
  } else {
    addr = `/checker/logincheck_Nba`;
  }

  try {
    const res = await axios.post(addr, body);
    console.log("✅ success: ", res);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};

// 로긴 체크_리얼 클래스
export const LoginCheckWeb_Realclass = async (id: string, pw: string) => {
  // 이메일 로그인만 지원 가능
  const body = {
    id: id,
    pw: pw,
  };

  try {
    let addr;

    if (isDevMode) {
      addr = `/loginChecker/logincheck_Realclass`;
    } else {
      addr = `/checker/logincheck_Realclass`;
    }

    const res = await axios.post(addr, body);
    // console.log("✅ success: ", res.data);

    return res.data.data;
  } catch (error) {
    console.log("🚨 error: ", error);
    return false;
  }
};
